<template>
	<div class="mt-2">
		<ListItem is-recipient info>
			<template #text>
				<div class="message-list--item-vita-upload p-0">
					<div>
						<Icon icon="vita"/>
					</div>
					<div>
						<a :href="vitaUrl" target="_blank">{{ vitaInfo.documentName }}</a>
					</div>
				</div>
			</template>
		</ListItem>
		<ListItem is-recipient>
			<template #text>
				Jetzt solltest du schnell reagieren!
			</template>
		</ListItem>
	</div>
</template>

<script>
import ListItem from "@/vue/communication/conversation/message/ListItem.vue";
import Icon from "@/vue/icon/Icon.vue";

export default {
	components: {Icon, ListItem},

	props: {
		conversation: {
			type: Object,
			required: true
		},
		vitaInfo: {
			type: Object,
			required: true
		},
	},

	computed: {
		vitaUrl ()
		{
			return '/kommunikation/abstimmung/' + this.conversation.id + '/lebenslauf/' + this.vitaInfo.documentName;
		}
	}
}
</script>